module.exports = __webpack_public_path__ + "img/powered-by-light.0e950383.svg";